<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix">
      <div class="pull-left">
        <h3 class="m-v-0">{{collection.name}}</h3>
        <span>
          {{collection.time_create | sub(0, -3)}}
          <span v-if="collection.status === '禁用'" class="text-warning">已禁用</span>
        </span>
      </div>
      <div class="pull-right">
        <router-link v-if="$location.admin_collection_edit.auth()"
                     :to="$location.admin_collection_edit({collection_uid: collection.uid})"
                     class="el-button el-button--success el-button--cons">
          编辑
        </router-link>
        <el-button type="warning" size="cons" @click="toggleDisabled()" :loading="submit_loading>0">
          {{collection.status === '禁用' ? '启用' : '禁用'}}
        </el-button>
        <el-button type="danger" size="cons" @click="remove()" :loading="submit_loading>0">删除</el-button>
        <el-button type="default" @click="$router.back()" size="cons">返回</el-button>
      </div>
    </div>
    <hr>
    <el-form label-width="6em" label-position="left" class="m-v-5">
      <el-form-item label="所属部门" class="m-0">
        {{department_map[collection.department_uid]}}
      </el-form-item>
      <el-form-item label="具体要求" class="m-0">
        <span class="text-pre-wrap l-h-n m-t-8">{{collection.desc}}</span>
      </el-form-item>
      <el-form-item label="附件" v-if="collection.file" class="m-0">
        <a :href="collection.file.url" :download="collection.file.name" target="_blank"
           class="link-success">
          <icon :name="collection.file.name | fileicon"></icon>
          {{collection.file.name}}
        </a>
      </el-form-item>
    </el-form>
    <div class="clearfix m-t-10 m-b-5">
      <div class="pull-left m-t-5">
        已收到 {{collection.teachers.length}} 份教师提交计划
      </div>
      <div class="pull-right">
        <el-button type="primary" size="cons" @click="batchDownload()" :loading="download_loading>0">批量下载
        </el-button>
        <el-input placeholder="搜索教师" class="max-width-200 w-a"
                  suffix-icon="el-icon-search" v-model="search"></el-input>
      </div>
    </div>
    <el-table :data="page" border>
      <el-table-column prop="teacher_name" label="教师">
        <template slot-scope="scope">
          <div v-html="$highlight(scope.row.teacher_name, scope.row.$$pinyin.teacher_name)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="teacher_desc" label="备注">
        <template slot-scope="scope">
          <el-tooltip placement="bottom">
            <div class="text-ellipsis max-height-100">
              <span class="text-pre-wrap">{{scope.row.teacher_desc}}</span>
            </div>
            <div slot="content" class="text-pre-wrap">{{scope.row.teacher_desc}}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="teacher_file.name" label="文件">
        <template slot-scope="scope">
          <a :href="scope.row.teacher_file.url" :download="scope.row.teacher_file.name" target="_blank"
             class="link-success">
            <icon :name="scope.row.teacher_file.name | fileicon"></icon>
            {{scope.row.teacher_file.name}}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="操作" class-name="no-padding" align="center">
        <template slot-scope="scope">
          <a :href="scope.row.teacher_file.url" :download="scope.row.teacher_file.name" target="_blank"
             class="el-button el-button--success el-button--mini">
            下载
          </a>
          <el-button type="danger" size="mini" @click="removeCollection(scope.row)"
                     :loading="scope.row.$$loading>0">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filtered.length>pageInfo.page" :total="filtered.length"
                   :page-size="pageInfo.page" :current-page.sync="pageInfo.current"
                   class="text-center m-t-10" layout="prev, pager, next"></el-pagination>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy'
import mapValues from 'lodash/mapValues'
import assign from 'lodash/assign'

import * as Collection from 'api/collection'
import * as Department from 'api/department'

import page from 'utils/page'

export default {
  data () {
    return {
      collection: null,
      search: '',
      pageInfo: {page: 10, current: 1},
      submit_loading: 0,
      download_loading: 0,
      ready: false,
    }
  },
  computed: {
    filtered () {
      return this.$search(this.collection.teachers, this.search, ['user_name'])
    },
    page () {
      return page(this.filtered, this.pageInfo)
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [collectoin, departments] = await Promise.all([
          Collection.get({uid: this.$query.collection_uid}),
          Department.list(),
        ])
        this.departments = departments
        this.department_map = mapValues(keyBy(departments, 'uid'), 'name')
        this.collection = collectoin
        this.ready = true
      })
    },
    async remove () {
      if (this.submit_loading) return
      if (!await this.$dangerConfirm('您确定要删除该任务吗？')) return
      this.$guard(this, 'submit_loading')(async () => {
        await Collection.remove(this.collection)
        this.$message.success('删除成功')
        this.$router.back()
      })
    },
    async toggleDisabled () {
      if (this.submit_loading) return
      if (this.collection.status !== '禁用' && !await this.$confirm('您确定要禁用该任务吗？', '提示')) return
      this.$guard(this.collection, '$$loading')(async () => {
        let data = await Collection.toggle_disable(this.collection)
        assign(this.collection, data)
        this.$message.success(this.collection.status !== '禁用' ? '禁用成功' : '启用成功')
      })
    },
    async removeCollection (item) {
      if (item.$$loading) return
      if (!await this.$dangerConfirm('您确定要删除该教师计划吗？')) return
      this.$guard(item, '$$loading')(async () => {
        await Collection.teacher_remove({user_uid: item.teacher_uid, uid: this.collection.uid})
        this.$message.success('删除成功')
        let idx = this.collection.teachers.indexOf(item)
        this.collection.teachers.splice(idx, 1)
      })
    },
    async batchDownload () {
      this.$guard(this, 'download_loading')(async () => {
        window.location.href = await Collection.batch_download({uid: this.$query.collection_uid})
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/collection/AdminCollectionView.vue